import { jsxs as B, Fragment as j, jsx as e } from "react/jsx-runtime";
import { FormikContext as A, Field as V } from "formik";
import { forwardRef as E, useContext as G, useState as I, useMemo as q, useEffect as H } from "react";
import { Tooltip as J } from "../Tooltip/Tooltip.es.js";
import { useMultiStyleConfig as K, chakra as T, IconButton as _ } from "@chakra-ui/react";
import { FormLabel as N } from "../Form/FormLabel.es.js";
import { MagicAniamtedFilledIcon as O } from "../MagicAniamtedFilledIcon/MagicAniamtedFilledIcon.es.js";
import { SmartAnimation as Q } from "../SmartAnimation/SmartAnimation.es.js";
import { ReloadIcon as U, CloseIcon as g } from "../../icons/index.es.js";
const oe = E(
  ({
    __css: b,
    clearButtonProps: v,
    disableFormik: h = !1,
    isError: l,
    isSmartData: a = !1,
    isSmartDataLoading: i = !1,
    label: y,
    name: o,
    onChange: R,
    onClear: r,
    onRetry: S,
    placeholder: c,
    resize: F = "none",
    sx: k,
    trackId: z,
    value: d,
    ...f
  }, C) => {
    const t = G(A), s = K("TextareaTheme", {
      variant: l ? "error" : f.variant
    }), [M, m] = I(!1), [n, u] = I(d), p = o ? t == null ? void 0 : t.values[o] : void 0, w = q(() => a && i && !c ? "Gathering data..." : c, [a, i, c]);
    !h && t && !o && console.warn("Input component is used inside Formik context without a name prop");
    const x = t && !h && o;
    return H(() => {
      u(d);
    }, [d]), /* @__PURE__ */ B(j, { children: [
      y && /* @__PURE__ */ e(N, { children: y + " " }),
      /* @__PURE__ */ B(
        Q,
        {
          isLoading: i,
          __cssContent: { borderRadius: "radius-100" },
          size: "fullwidth",
          children: [
            x ? /* @__PURE__ */ e(
              V,
              {
                __css: { ...s.textarea, ...b },
                as: T.textarea,
                "data-smart-loading": i ? "true" : "false",
                name: o,
                placeholder: w,
                ref: C,
                resize: F,
                sx: k,
                "track-id": z,
                ...f
              }
            ) : /* @__PURE__ */ e(
              T.textarea,
              {
                __css: { ...s.textarea, ...b },
                "data-smart-loading": i ? "true" : "false",
                name: o,
                onChange: R,
                placeholder: w,
                ref: C,
                resize: F,
                sx: k,
                "track-id": z,
                value: n,
                ...f
              }
            ),
            a && !M && /* @__PURE__ */ e(
              _,
              {
                boxSize: 4,
                __css: s.iconButton,
                "aria-label": "Smart Data loading",
                onClick: l ? S : void 0,
                icon: l ? /* @__PURE__ */ e(U, { boxSize: 4, color: "primary.300" }) : /* @__PURE__ */ e(
                  O,
                  {
                    animated: i,
                    onMouseEnter: () => {
                      (n || p) && m(!0);
                    }
                  }
                )
              }
            ),
            (n || p) && !a && /* @__PURE__ */ e(
              _,
              {
                __css: s.iconButton,
                "aria-label": "Clear",
                icon: /* @__PURE__ */ e(g, { boxSize: 4, color: "primary.300" }),
                onClick: () => {
                  u(""), r == null || r(), o && x && t.setFieldValue(o, "");
                },
                size: "sm",
                variant: "transparent",
                ...v
              }
            ),
            (n || p) && a && M && /* @__PURE__ */ e(
              J,
              {
                label: "Clear info added by Smart Profiles",
                "aria-label": "Clear info added by Smart Profiles",
                placement: "top-end",
                children: /* @__PURE__ */ e(
                  _,
                  {
                    __css: s.iconButton,
                    "aria-label": "Clear",
                    icon: /* @__PURE__ */ e(g, { boxSize: 4, color: "primary.300" }),
                    onMouseLeave: () => m(!1),
                    onClick: () => {
                      u(""), r == null || r(), m(!1), o && x && t.setFieldValue(o, "");
                    },
                    size: "sm",
                    variant: "transparent",
                    ...v
                  }
                )
              }
            )
          ]
        }
      )
    ] });
  }
);
export {
  oe as Textarea
};
//# sourceMappingURL=Textarea.es.js.map
